import React from 'react';
import styled from 'styled-components';

import WorkflowItem from '../WorkflowItem';

import { WorkflowListProps } from './types';

const StyledContainer = styled.div`
  padding-bottom: 1rem;
`;

const StyledWorkflowItem = styled(WorkflowItem)`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const renderWorkflows = (workflows: WorkflowListProps['workflows']) => (
  workflows.map((workflow) => (
    <StyledWorkflowItem
      key={workflow.guid}
      workflow={workflow}
    />
  ))
);

const WorkflowList = ({
  workflows,
}: WorkflowListProps) => {
  return (
    <StyledContainer>
      {renderWorkflows(workflows)}
    </StyledContainer>
  );
};

export default WorkflowList;
